<template>
    <div>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <div v-on="on">
                    <cp-icon-button
                        title="Reenviar Cobrança"
                        icon="$emailSyncOutline"
                        color="warning"
                        @click.prevent="openModal"
                    />
                </div>
            </template>
            <span>Reenviar Cobrança</span>
        </v-tooltip>
        <cp-simple-modal ref="simple-modal">
            <template #body>
                <v-card>
                    <v-card-text class="pa-4 black--text body-2">
                        <div class="mb-4">
                            {{ message }}
                        </div>
                        <v-text-field
                            v-model="email"
                            label="E-mail"
                            placeholder="Enviar para outro e-mail?"
                            persistent-hint
                            hint="Caso queira enviar para outro e-mail, informe o endereço."
                            :error-messages="emailErrors"
                            @blur="emailErrors = []"
                        />
                    </v-card-text>
                </v-card>
            </template>
            <template #actions>
                <cp-button
                    color="secondary"
                    @click="clear"
                    :disabled="loading"
                    :loading="loading"
                >
                    Cancelar
                </cp-button>
                <cp-button
                    color="primary"
                    @click="confirm"
                    :disabled="loading"
                    :loading="loading"
                >
                    Reenviar
                </cp-button>
            </template>
        </cp-simple-modal>
    </div>
</template>

<script>
export default {
    props: {
        bill: {
            type: Object,
            required: true,
        },
        client: {
            type: Object,
            default: null,
        },
        routeName: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        email: '',
        loading: false,
        emailErrors: [],
    }),

    computed: {
        clientId() {
            return this.client?.id ?? this.bill.company?.id ?? null
        },

        clientEmail() {
            return this.client?.charge_email
                ?? this.bill.company?.charge_email
                ?? ''
        },

        clientName() {
            return this.client?.trade_name
                ?? this.client?.legal_name
                ?? this.bill.company?.trade_name
                ?? this.bill.company?.legal_name
                ?? 'o cliente'
        },

        message() {
            if (this.clientEmail) {
                return `Deseja reenviar a cobrança da fatura ${this.bill.external_id} para ${this.clientName} (${this.clientEmail})?`
            }

            return `Deseja reenviar a cobrança da fatura ${this.bill.external_id}?`
        },
    },

    methods: {
        openModal() {
            this.email = ''
            this.emailErrors = []

            this.$refs['simple-modal'].open({
                title: 'Reenviar cobrança',
                persistent: true,
            })
        },

        clear() {
            this.email = ''
            this.emailErrors = []
            this.loading = false
            this.$refs['simple-modal'].close()
        },

        confirm() {
            if (!this.clientId) {
                return
            }

            this.loading = true

            axios.post(
                this.route(this.routeName, {bill: this.bill.id}),
                {email: this.email || this.clientEmail}
            ).then(() => {
                this.$bus.$emit('feedback', {
                    message: 'Cobrança reenviada com sucesso.',
                })

                this.clear()
            }).catch(error => {
                this.loading = false

                let message = 'Erro ao reenviar cobrança.'

                if (_.get(error, 'response.status') === 422) {
                    const errors = error.response.data.errors ?? {}

                    this.emailErrors = errors.email ?? []

                    _.each(errors, (item) => {
                        message = `${item[0]} `
                    })
                } else if (error.response?.data?.message) {
                    message = error.response.data.message
                }

                this.$bus.$emit('feedback', {
                    message,
                    type: 'error',
                })
            })
        },
    },
}
</script>
